module.exports = __webpack_public_path__ + "img/symbol_2.d9bb4ea7.png";